export default {
  map_unavailable: "La carte n'a pas pu être chargée. Rechargez la page pour réessayer.",
  stubs: {
    name: 'Zone de livraison {{number}}',
  },
  buttons: {
    add_new_zone: 'Ajouter une zone',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des zones de livraison',
  },
};
